/*
 * @Author: Teemo Ding
 * @Date: 2021-09-18 13:30:50
 * @LastEditTime: 2022-06-01 16:57:32
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/ShippingZone/index.tsx
 */
import { Button, SizeFittingTable } from '@/src/components/Antd';
import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import { useStoreCountries } from '@/src/pages/Settings/Components/SelectCountryArea';
import { delShippingZone } from '@/src/request/settings/logistics/shippingRate';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { Spin } from 'antd';
import React, { useRef, useState } from 'react';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import ShippingZoneModal, {
  useShippingZoneOptionsModal,
} from './Components/ShippingZoneModal';
import { columns } from './config';
import styles from './css.module.less';

const permissions = () => {
  const add_edit_shipping_zone = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsShippingZone,
        operation: EnumOperation.add_edit_shipping_zone,
      }),
    ],
  });
  const delete_shipping_zone = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.delete_shipping_zone,
      }),
    ],
  });

  return {
    add_edit_shipping_zone,
    delete_shipping_zone,
  };
};

const ShippingZone = ({
  modalOp: { setShowModal, setModalTitle, setModalContent },
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { add_edit_shipping_zone, delete_shipping_zone } = permissions();
  const childRef = useRef<any>();
  const { list: countriesList = [] } = useStoreCountries();
  const [selectIndex, setSelectIndex] = useState<any>();

  const {
    loading: getShippingZoneListLoading,
    list,
    reFresh: reFreshSelectOptions,
  } = useShippingZoneOptionsModal();

  const { loading: delShippingZoneLoading, run: _delShippingZone } = useRequest(
    (uuid) => delShippingZone(uuid),
    {
      manual: true,
      onSuccess(result) {
        reFreshSelectOptions();
      },
    },
  );

  const handleDelete = (uuid) => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {getI18n('storeLogistics.shippingZone.deleteShippingZone')}
      </ErrorModalTitle>,
    );
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        onSubmit={() => _delShippingZone(uuid)}
        errorText={getI18n(
          'storeLogistics.shippingZone.deleteShippingZoneErrorText',
        )}
        okText={getI18n('general.delete')}
      />,
    );
  };

  const handleEdit = (record) => {
    setSelectIndex(record);
    if (childRef?.current) childRef.current.showModal();
  };
  const handleAd = () => {
    setSelectIndex(null);
    if (childRef?.current) childRef.current.showModal();
  };
  const onShippingRateEditSuccess = () => {
    reFreshSelectOptions();
  };

  return (
    <div className={styles.shippingRateList}>
      <Spin spinning={delShippingZoneLoading || getShippingZoneListLoading}>
        <div className={styles.table}>
          <SizeFittingTable
            id='ShippingZoneTable'
            rowKey='uuid'
            pagination={false}
            dataSource={list}
            className={styles.shippingZoneTable}
            columns={columns(
              handleDelete,
              handleEdit,
              countriesList,
              add_edit_shipping_zone,
              delete_shipping_zone,
              { getI18n },
            )}
            rowClassName={styles.row}
          />
          <ShippingZoneModal
            cRef={childRef}
            list={countriesList}
            modalTitle={getI18n('storeLogistics.shippingZone.addshippingzone')}
            selectOptions={list}
            initialValues={selectIndex ? selectIndex : {}}
            onSuccess={onShippingRateEditSuccess}>
            {null}
          </ShippingZoneModal>
          <Button
            className={styles.button}
            onClick={handleAd}
            type='primary'
            disabled={!add_edit_shipping_zone}>
            {getI18n('storeLogistics.shippingZone.addShippingZone')}
          </Button>
        </div>
      </Spin>
    </div>
  );
};

export default ModalHoc(ShippingZone);
